@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/buttons' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-select-event-type {
  height: inherit;
  overflow-y: auto;

  div.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--nylas-base-200);

    h2 {
      font-size: 18px;
      padding: 0 24px;
      line-height: 24px;
      margin: 0;
      font-weight: 600;
      color: var(--nylas-base-800);
    }

    button-component {
      button {
        @include invisible-button;
      }
    }
  }

  div.content {
    padding: 40px;

    h3 {
      margin: 0 0 32px 0;
      font-size: 18px;
      line-height: 24px;
      font-weight: 600;
    }

    div.event-type {
      display: flex;
      flex-direction: column;
      gap: 8px;

      div.event-type-option {
        padding: 16px;
        border: 1px solid var(--nylas-base-200);
        border-radius: var(--nylas-border-radius-3x);
        width: inherit;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: 8px;

        h4 {
          margin: 0;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          color: var(--nylas-base-900);
        }

        p {
          margin: 0;
          font-size: 14px;
          line-height: 21px;
          font-weight: 400;
          color: var(--nylas-base-800);
        }
      }
    }
  }
}
